import * as angular from "angular";
import {IScope} from "angular";

export interface CroppieDialogScope extends IScope {
    closeDialog: () => void;
    onAvatarUploadStart: () => void;
    //image base64
    onAvatarUpload: (resp: any) => void;
    file: string;
    readFile: () => void;
    showLoader: boolean;
}

export class CroppieDialog {

    static instance = ($event): angular.material.IDialogOptions => ({
        template: require('./CroppieDialog.html'),
        parent: angular.element(document.body),
        controller: ['$scope', '$mdDialog', CroppieDialog],
        targetEvent: $event,
        fullscreen: true
    });

    private $scope: CroppieDialogScope;
    private $mdDialog: angular.material.IDialogService;


    constructor($scope: CroppieDialogScope,
                $mdDialog: angular.material.IDialogService) {
        $scope.onAvatarUpload = this.onAvatarUploadFinish;
        $scope.onAvatarUploadStart = this.onAvatarUploadStart;
        $scope.showLoader = false;
        $scope.closeDialog = this.closeDialog;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
    }

    closeDialog = () => {
        this.$mdDialog.cancel();
    };

    onAvatarUploadFinish = (imageResp) => {
        this.$scope.showLoader = false;
        this.$mdDialog.hide(imageResp);
    };

    onAvatarUploadStart = () => {
        this.$scope.showLoader = true;
    }
}